"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreConsumer = exports.StoreProviderComponent = void 0;
const react_1 = __importDefault(require("react"));
const StoreContext = react_1.default.createContext({
    store: null,
    updateStore: () => { throw new Error("updateStore function not implemented"); },
});
class StoreProvider extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.updateStore = (key, value) => {
            this.state.store.setValue(key, value);
            this.setState({ store: this.state.store });
        };
        this.state = {
            store: this.props.store,
            updateStore: this.updateStore,
        };
    }
    render() {
        return react_1.default.createElement(StoreContext.Provider, { value: this.state }, this.props.children);
    }
}
exports.StoreProviderComponent = StoreProvider;
exports.StoreConsumer = StoreContext.Consumer;
